import React, {useEffect} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {Link} from 'react-router-dom'
import './styles/estado-documento.css'
import EDFromFiltros from './Components/EDFromFiltros'
import WhitePlus from '../../../media/felsv/white_plus-small_icon.svg'
import ModalsControls from './modals/ModalsControls'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsGUEstadoDocumentos} from '../../../actions/action-creators'
import { Sucursales } from './Components/Sucursales'
import { Documentos } from './Components/Documentos'
import { State } from '../../../reducers'
import { getTiposDocumentoEmision } from '../../../actions/catalogos.actions'

const EstadoDocumento = () => {
  const dispatch = useDispatch()
  const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
  const actions = bindActionCreators(actionsGUEstadoDocumentos, dispatch)

  useEffect(() => {
    window.scroll(0, 0)
    actions.gu_ed_GetEstadosDocumento()

    if (tipoDocumentosEmision.length === 0) { dispatch(getTiposDocumentoEmision()) }
    return () => {
      dispatch(actions.gu_ed_Clear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BasicLayout>
      <ModalsControls />
      {/* Encabezado */}
      <div className='header-link'>
        <Link to='/gestion-usuarios' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Estado de Sucursales y Documentos</h3>
      </div>
      <div className='separador'></div>
      {/* Filtro */}
      {/* <div
        className='w-100 button-actions'
        style={{display: 'flex', justifyContent: 'space-between', alignItems: 'end'}}
      >
        <EDFromFiltros />
      </div> */}
      <Sucursales />
      <Documentos />
    </BasicLayout>
  )
}

export default EstadoDocumento
